import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from './pages/login.component';
import Index from './pages/index.component';
import './App.css';
import Contact from './pages/contact.component';
import Users from './pages/users.component';
import { connect } from 'react-redux';
import ToastComponent from './comman/component/toast.component';
import { useHistory } from 'react-router-dom';
import Settings from './pages/settings.component';
import Header from './comman/component/header.component';
import SideNav from './comman/component/sidenav.component';
import { setActiveTab } from './redux/active-tabs/active-tab.action';
import GalleryView from './pages/gallery.component';
import ProfilePage from './pages/profile.component';
import ResetPassword from './pages/resetpassword.component';
import forgotpasswordComponent from './pages/forgotpassword.component';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const App = ({ toast, token, setActiveTab }) => {
  const history = useHistory();
  if (token) {
    if (history.location.pathname === '/') {
      setActiveTab('home');
      history.push('/index');
    }
  } else if (history.location.pathname === '/forgotpassword') {
    history.push('/forgotpassword');
  } else if (history.location.pathname.includes('/reset')) {
    // history.push("/reset");
    console.log(history.location.pathname);
  } else {
    history.push('/');
  }

  return (
    <div className='App'>
      {/* Trick for useToast hook */}

      {/* <ToastContainer
        position='top-right'
        // autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        limit={1}
      /> */}
      {/* <ToastComponent /> */}
      {Object.keys(toast).length > 0 ? (
        toast.show ? (
          <ToastComponent />
        ) : null
      ) : null}
      {history.location.pathname !== '/' && token && (
        <>
          <Header />
          <SideNav />
        </>
      )}
      <Switch>
        <Route exact path='/' component={Login}></Route>
        <Route path='/reset' component={ResetPassword}></Route>
        <Route
          path='/forgotpassword'
          component={forgotpasswordComponent}></Route>
        <Route exact path='/index' component={Index}></Route>
        <Route exact path='/contact' component={Contact}></Route>
        <Route exact path='/users' component={Users}></Route>
        <Route exact path='/setting' component={Settings}></Route>
        <Route exact path='/gallery' component={GalleryView}></Route>
        <Route exact path='/profile' component={ProfilePage}></Route>
      </Switch>
    </div>
  );
};

const mapStateToProps = ({ authReducer: { toast, token } }) => ({
  toast: toast,
  token: token,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveTab: (data) => dispatch(setActiveTab(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
